// Module-level capture: set the first time this module is imported.
// Used to measure elapsed time from app start to milestone events
// (auth ready, project list painted, etc.).
export const BOOT_START_MS = performance.now()

export function bootElapsed(): number {
  return Math.round(performance.now() - BOOT_START_MS)
}
